import { getMailSignatureCloudSettingsStore } from '../store/store';

export function isMailSignatureCloudSettingsInitialized(): boolean {
    const store = getMailSignatureCloudSettingsStore();
    // Return true only if at least one of the values in the store is valid
    return Object.values(store).some(value => value !== null);
}
